import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './CustomFormFields.scss';
import { Combobox, IconSettings } from '@salesforce/design-system-react';

export const PicklistField = ({ enabled, required, label, fieldName, handleChange, values, error, defaultValue, isCombobox }) => {
  const [state, setState] = useState({ inputValue: '', selection: [] });
  const placeholderText = enabled ? `Search ${label}` : '';
  const formattedValues = values.map((value) => ({ id: value.value, label: value.label }));

  useEffect(() => {
    if (defaultValue) {
      const defaultOption = formattedValues.find((option) => option?.id === defaultValue || option?.label === defaultValue);
      if (defaultOption) {
        setState({ inputValue: '', selection: [{ id: defaultOption?.id, label: defaultOption?.label }] });
        // Register the prepopulated default in the parent form state so validation passes without manual interaction
        handleChange(null, { fieldName, value: defaultOption?.id });
      }
    }
  }, [defaultValue]);

  return (
    <div className='picklist-field'>
      <IconSettings iconPath='/assets'>
        <Combobox
          id="combobox-readonly-single"
          events={{
            onSelect: (event, data) => {
              isCombobox ?
                setState({ inputValue: data.selection[0]?.label, selection: [] }) :
                setState({ inputValue: '', selection: data.selection });
              handleChange(event, { fieldName, value: isCombobox ? data.selection[0]?.label : data.selection[0]?.id });
            },
            onChange: (event, data) => {
              if (isCombobox) {
                setState({ inputValue: event.target.value, selection: [] });
                handleChange(event, { fieldName, value: event.target.value });
              }
            },
          }}
          labels={{
            label,
            placeholderReadOnly: !isCombobox && placeholderText,
            placeholder: isCombobox && placeholderText,
          }}
          options={formattedValues}
          selection={state.selection}
          value={
            state.selection && !isCombobox ?
              state.selection.label :
              state.inputValue
          }
          isEditable={isCombobox}
          singleInputDisabled={!enabled}
          required={required}
          variant={isCombobox ? 'inline-listbox' : 'readonly'}
          errorText={error}
        />
        { label === 'Rate' && <div className='slds-form-element__help picklist-field-rate-help'>Rate will be assigned upon save and cannot be selected here</div> }
      </IconSettings>
    </div>
  );
};

PicklistField.propTypes = {
  enabled: PropTypes.bool,
  required: PropTypes.bool,
  fieldName: PropTypes.string,
  handleChange: PropTypes.func,
  label: PropTypes.string,
  values: PropTypes.array,
  error: PropTypes.string,
  defaultValue: PropTypes.string,
  isCombobox: PropTypes.bool,
};
